import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { IUser } from '../interfaces/user.interface';

/**
 * Is dit een super-admin? In het token kan `role` één tekst zijn of, bij meer
 * rollen, een lijst.
 */
export function isSuperAdmin(user: IUser | null | undefined): boolean {
  const rol: unknown = user?.role;
  return Array.isArray(rol) ? rol.includes('super_admin') : rol === 'super_admin';
}

/**
 * Alleen voor super-admins. De gateway laat alleen hen met `?club=` bij een
 * andere club; iemand anders zou in de editor zijn eigen club aanpassen
 * terwijl er een andere op het scherm staat.
 */
export const superAdminGuard = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  if (isSuperAdmin(authService.user)) {
    return true;
  }
  inject(ToastrService).error('Only a super admin can edit club panels.');
  return inject(Router).createUrlTree(['/panels/club']);
};
